import 'eonasdan-datetimepicker';

const setFontAwesomeDefaultIcons = () => {
  $.fn.datetimepicker.defaults.icons = {
    time: 'fa fa-clock-o',
    date: 'fa fa-calendar',
    up: 'fa fa-chevron-up',
    down: 'fa fa-chevron-down',
    previous: 'fa fa-angle-double-left',
    next: 'fa fa-angle-double-right',
    today: 'fa fa-dot-circle-o',
    clear: 'fa fa-trash',
    close: 'fa fa-times',
  };
};

const DEFAULTS = {
  locale: 'en-au'
};

class Datetimepicker {
  constructor($element, options = {}) {
    this.config = Object.assign({}, DEFAULTS, options);

    if ($element.size()) {
      this.initialize($element);
    }
  }

  initialize($element) {
    setFontAwesomeDefaultIcons();
    $element.datetimepicker(this.config);
  }
}

export default Datetimepicker;



// WEBPACK FOOTER //
// ./src/javascripts/Datetimepicker.js